import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rates: [
    [{
      plan: '',
      recommendedPlan: '',
      HousingInterestRate: '',
      AverageBankInterestRate: '',
      GeneralPurposeInterestRate: '',
      AverageInterestRate: '',
      weight: '',
    }],
    [{
      plan: '',
      recommendedPlan: '',
      HousingInterestRate: '',
      AverageBankInterestRate: '',
      GeneralPurposeInterestRate: '',
      AverageInterestRate: '',
      weight: '',
    }],
  ],
};

const rateSlice = createSlice({
  name: 'rate',
  initialState,
  reducers: {
    updateRate: (state, action) => ({ ...state, ...action.payload }),
    resetRate: () => initialState,
  },
});

export const { updateRate } = rateSlice.actions;
export default rateSlice.reducer;
